module.exports = __webpack_public_path__ + "img/time.947cd6bb.svg";